const Constants = {
  emailTemplateID: "sdp_email_notification",
  daikinAdminEmail: "harinakshi.rao@softway.com",
  auth0: {
    dev: {
      domain: "dev-ik40hiijwbl0uacg.us.auth0.com",
      clientId: "snGTKJtL7Ezqynt3lNwAa2Lu5HNd5IE0",
    },
  },
  privacyPolicy: "https://www.daikincity.com/DaikinCityB2BTermsOfUse.html",
  termsOfUse: "https://www.daikincity.com/DaikinCityB2BTermsOfUse.html",
  userRoles: {
    admin: "admin",
  },
};

export default Constants;
